import { render, staticRenderFns } from "./myTravelogue.vue?vue&type=template&id=67bed96a&"
import script from "./myTravelogue.vue?vue&type=script&lang=js&"
export * from "./myTravelogue.vue?vue&type=script&lang=js&"
import style0 from "./myTravelogue.vue?vue&type=style&index=0&id=67bed96a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports